<template>
  <stats-board :stats="stats" board="statistics" page="statistics" :refreshing="refreshing" @refresh="refreshStats">
    <template #intro>
      <div class="zh-eyebrow"><span class="zh-dot"></span> Live · updated {{ updatedLabel }}</div>
      <h1 class="zh-title">Platform <span>statistics</span></h1>
      <p class="zh-sub">Forests, carbon and credits of Zerticarbon in real time. Make it yours: move, resize and choose the cards.</p>
    </template>
  </stats-board>
</template>

<script>
import { mapGetters } from 'vuex';
import StatsBoard from '../components/Stats/StatsBoard.vue';
import statsData from '../components/Stats/statsData';
import { timeAgo } from '../components/Stats/theme';
import adminOnlyPage from '../mixins/adminOnlyPage';

export default {
  name: 'Statistics',
  components: { StatsBoard },
  mixins: [adminOnlyPage, statsData],
  beforeRouteEnter(to, from, next) {
    next(async (vm) => {
      if (!vm.getWeb2ActiveAccount) {
        await vm.$store.dispatch('user/initWeb2');
      }
      if (!vm.getWeb2ActiveAccount || vm.getWeb2ActiveAccount.role.name !== 'Administrator') {
        vm.$router.replace('/');
      }
    });
  },
  data() {
    return { clock: 0, clockTimer: null };
  },
  computed: {
    ...mapGetters('user', ['getWeb2ActiveAccount']),
    updatedLabel() { void this.clock; return this.lastUpdated ? timeAgo(this.lastUpdated) : '…'; }
  },
  created() {
    this.startGlobal();
    this.clockTimer = setInterval(() => { this.clock += 1; }, 15000);
  },
  beforeDestroy() {
    clearInterval(this.clockTimer);
  }
};
</script>

<style scoped lang="scss">
@import '../components/Stats/intro.scss';
</style>
